(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/models/single-rows/betslip-singlerows.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/models/single-rows/betslip-singlerows.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.tipset.models.BetslipSinglerows = Backbone.Model.extend({
    initialize: function() {
      var self = this;

      this.listenTo(
        svs.tipset.models.weekPicker,
        'nrOfWeeksUpdated',
        this.couponChanged
      );
      this.listenTo(
        svs.tipset.collections.boardCollections,
        'boardDataChanged allBoardsUpdated',
        this.couponChanged
      );
      this.listenTo(
        svs.tipset.models.sportkryss,
        'sportkryssUpdated',
        this.couponChanged
      );
      this.listenTo(
        svs.tipset.models.betslipExpanded,
        'change:amount',
        this.couponChanged
      );
      this.listenTo(
        svs.tipset.models.bombenXperten,
        'bombenSet bombenRemoved',
        this.couponChanged
      );

      svs.components.account_balance.get(function(balance) {
        var currencyBalance =
          balance != null ? svs.utils.format.Currency(balance) : null;
        self.set('accountBalance', currencyBalance);
        self.set('userAccountBalace', currencyBalance);
        self.couponChanged();
      });

      svs.components.account_balance.on('change', this.setAccountBalance, this);

      this.set(
        {
          rowPrices: svs.tipset.models.gameDefinitions.get('rowPrices'),
          amount: svs.tipset.models.gameDefinitions.get('rowPrices')[0],
          showWeeks:
            svs.tipset.models.gameDefinitions.get('productName') !=
            svs.tipset.constants.PRODUCTNAME.TOPPTIPSET
        },
        { silent: true }
      );
      this.setModelData(true);
    },

    setAccountBalance: function(balance) {
      this.set(
        'accountBalance',
        balance != null ? svs.utils.format.Currency(balance) : null
      );
      this.couponChanged();
    },

    setModelData: function(silent) {
      var betslipData = this.generateBetslipData(),
        nrOfRows =
          svs.tipset.collections.boardCollections &&
          svs.tipset.collections.boardCollections.getNrOfRows() > 0
            ? svs.tipset.collections.boardCollections.getNrOfRows()
            : 1,
        isPayable = this.isPayable(),
        numWeeks =
          svs.tipset.models.gameDefinitions.hasWeekPicker() &&
          svs.tipset.models.weekPicker
            ? svs.tipset.models.weekPicker.getNumberOfWeeks()
            : 1;
      this.set(
        {
          boardData: betslipData,
          noOfMatches: svs.tipset.data.gameDefinitions.numberOfMatches,
          price: this.getPrice(),
          numWeeks: numWeeks,
          totalCompleteRows: nrOfRows,
          isPayable: isPayable,
          sportkryss: this.hasValidSportkryssAmount()
        },
        { silent: silent }
      );
    },
    couponChanged: function() {
      this.setModelData(false);
    },
    hasValidSportkryssAmount: function() {
      return (
        svs.utils.ns.isNamespace('svs.tipset.models.sportkryss') &&
        svs.tipset.models.sportkryss.get('isValid') &&
        svs.tipset.models.sportkryss.get('sportkryssAmount') > 0
      );
    },
    generateBetslipData: function() {
      var boardList =
          svs.tipset.collections.boardCollections &&
          svs.tipset.collections.boardCollections.getCompleteBoardsData()
            ? svs.tipset.collections.boardCollections.getCompleteBoardsData()
            : undefined,
        draw =
          svs.tipset.collections.draws &&
          svs.tipset.collections.draws.getCurrentDraw()
            ? svs.tipset.collections.draws.getCurrentDraw()
            : undefined;

      if (draw != undefined) {
        var matchList = draw.get('drawEvents');
        var matches = new Backbone.Collection(matchList);
        var betslipBoard = [];

        matches.each(function(match, matchIndex) {
          var data = {
            match: match.toJSON(),
            matchIndex: matchIndex,
            matchNumber: match.get('eventNumber'),
            inRow: []
          };

          _.each(boardList, function(board) {
            if (board.get('boardData')[data.matchIndex]) {
              var sign = '';
              switch (board.get('boardData')[data.matchIndex]) {
                case 1:
                  sign = '1';
                  break;
                case 2:
                  sign = 'X';
                  break;
                case 4:
                  sign = '2';
                  break;
                default:
                  sign = '';
                  break;
              }
              data.inRow.push(sign);
            }
          });
          betslipBoard.push(data);
        });
        return betslipBoard;
      }
    },

    getPrice: function() {
      var nrOfRowsMultiplier =
          svs.tipset.collections.boardCollections &&
          svs.tipset.collections.boardCollections.getNrOfRows() > 0
            ? svs.tipset.collections.boardCollections.getNrOfRows()
            : 1,
        sportkryssAmount =
          svs.tipset.models.gameDefinitions.hasSportkryss() &&
          svs.utils.ns.isNamespace('svs.tipset.models.sportkryss')
            ? parseInt(svs.tipset.models.sportkryss.get('sportkryssAmount'), 10)
            : 0,
        numWeeks =
          svs.tipset.models.gameDefinitions.hasWeekPicker() &&
          svs.utils.ns.isNamespace('svs.tipset.models.weekPicker') &&
          svs.tipset.models.weekPicker.getNumberOfWeeks()
            ? svs.tipset.models.weekPicker.getNumberOfWeeks()
            : 1,
        price = nrOfRowsMultiplier,
        rowPrice = svs.tipset.models.betslipExpanded
          ? svs.tipset.models.betslipExpanded.get('amount')
          : 1,
        bombenAmount =
          svs.tipset.models.bombenXperten &&
          svs.tipset.models.bombenXperten.get('systemSize')
            ? svs.tipset.models.bombenXperten.get('systemSize')
            : 0;

      price *= numWeeks;
      price *= rowPrice;
      price += bombenAmount;

      if (sportkryssAmount > 0) {
        price += sportkryssAmount;
      }

      return price;
    },

    isPayable: function() {
      var isCorrectCoupon =
          svs.tipset.collections.boardCollections &&
          svs.tipset.collections.boardCollections.isPayable(),
        issportkryssCorrect = svs.utils.ns.isNamespace(
          'svs.tipset.models.sportkryss'
        )
          ? svs.tipset.models.sportkryss.get('isValid')
          : true,
        isValidSelfservice = true;

      if (
        svs.utils.ns.isNamespace('svs.core.config.data.svsconfig.isSelfService')
          ? svs.core.config.data.svsconfig.isSelfService
          : false
      ) {
        var nrOfRows =
            svs.tipset.collections.boardCollections &&
            svs.tipset.collections.boardCollections.getNrOfRows() > 0
              ? svs.tipset.collections.boardCollections.getNrOfRows()
              : 1,
          amount = svs.utils.ns.isNamespace('svs.tipset.models.betslipExpanded')
            ? svs.tipset.models.betslipExpanded.get('amount')
            : 1;

        isValidSelfservice = nrOfRows * amount >= 2;
      }

      return isCorrectCoupon && issportkryssCorrect && isValidSelfservice;
    },

    pay: function() {
      if (!svs.tipset.models.wager) {
        svs.tipset.models.wager = new svs.tipset.models.Wager();
      }
      svs.tipset.models.wager.startPaying();
    },

    getCouponPrice: function() {
      var sportkryssAmount = svs.utils.ns.isNamespace(
        'svs.tipset.models.sportkryss'
      )
          ? svs.tipset.models.sportkryss.get('sportkryssAmount')
          : 0,
        bombenAmount = svs.tipset.models.bombenXperten
          ? svs.tipset.models.bombenXperten.get('systemSize')
          : 0,
        totalAmount = this.get('price'),
        boardAmount =
          sportkryssAmount > 0 ? totalAmount - sportkryssAmount : totalAmount;

      return boardAmount - bombenAmount;
    },

    onBetAmountChanged: function(newAmount) {
      this.set('amount', newAmount, { silent: true });
      this.set({
        price: this.getPrice()
      });
    },

    getIsInCompetitionMode: function() {
      return false;
    },

    getIsM64: function() {
      return false;
    },

    destroy: function() {
      this.stopListening();
      svs.components.account_balance.off('change', this.setAccountBalance);
    }
  });
})(Backbone, _, svs);

 })(window);